const body = document.body;

const scrollUp = 'direction-up';
const scrollDown = 'direction-down';

const header = document.querySelector('.header');
const navbar = document.querySelector('.nav-bar');

var lastScrollTop = 0;

if (navbar) {
  window.addEventListener(
    'scroll',
    () => {
      var scrollPosition = window.scrollY || window.pageYOffSet;
      if (scrollPosition > lastScrollTop) {
        // downscroll code
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
        if (lastScrollTop == 0 && scrollPosition > 75) {
          body.classList.remove(scrollDown);
        }
      } else {
        // upscroll code
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
      }
      if (scrollPosition == 0) {
        body.classList.remove(scrollDown);
        body.classList.remove(scrollUp);
      }

      lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition;
    },
    false
  );
}
